let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h6T4w")).then(() => parcelRequire('atZnM'));